import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 30 30"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M12 2a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2h-6zm.025 4L9.953 9.225A5.99 5.99 0 0 0 9 12.469V26c0 1.103.897 2 2 2h8c1.103 0 2-.897 2-2V12.469c0-1.152-.33-2.273-.953-3.244L17.975 6h-5.95z" }, null, -1)
  ])))
}
export default { render: render }